import { useState } from "react"
import { Input } from "@/components/form/input"
import { csvToJson } from "../AdminImport/csvToJson"
import { ConfirmModal } from "@/components/modal/ConfirmModal"
import { validateImportFile } from "@/fetch/tasks"

type Props = {
  onClose: () => void
  onImport: (data: any) => void
  projectId: string
}

export const ReImportProject = ({ onClose, onImport, projectId }: Props) => {
  const [csvData, setCsvData] = useState<string>("")
  const [file, setFile] = useState<File | null>(null)

  const handleFileLoad = (e: React.ChangeEvent<HTMLInputElement>) => {
    const csv = e.target.files?.[0]
    const fileReader = new FileReader()
    if (csv) {
      setFile(csv)
      fileReader.readAsText(csv)
      fileReader.onload = (ev) => {
        if (ev.target?.result && typeof ev.target?.result === "string") {
          setCsvData(ev.target.result)
        }
      }
    }
  }

  const handleImport = async () => {
    if (csvData) {
      // Upload file to validation endpoint if file exists
      if (file) {
        try {
          await validateImportFile(file, "reimport", projectId)
        } catch (error) {
          console.error("Failed to validate import file:", error)
        }
      }

      const jsonData = csvToJson(csvData)
      onImport(jsonData)
    }
  }

  return (
    <ConfirmModal
      title="Re-importēt"
      onClose={onClose}
      onConfirm={handleImport}
      confirmText="Importēt"
    >
      <Input
        type="file"
        label="Izvēlieties CSV failu"
        onChange={handleFileLoad}
        accept=".csv"
      />
    </ConfirmModal>
  )
}
